var _circle, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8377,
    cy: 14.1624,
    r: 14.1624,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0271 18.901L7.33986 14.658C6.92544 14.1811 6.256 14.1811 5.84158 14.658C5.42716 15.1349 5.42716 15.9052 5.84158 16.3821L10.2833 21.4932C10.6977 21.9701 11.3672 21.9701 11.7816 21.4932L23.0241 8.55637C23.4385 8.07949 23.4385 7.30915 23.0241 6.83227C22.6096 6.35539 21.9402 6.35539 21.5258 6.83227L11.0271 18.901Z",
    fill: "#3C4977"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.90fdbd352e9a8d1c381f8ede6c320897.svg";
export { ForwardRef as ReactComponent };